import {Controller} from "@hotwired/stimulus"
import {formValidation, plugins} from "../../../../vendor/javascript/@form-validation/esm/bundle/popular"
import * as Bootstrap5 from "../../../../vendor/javascript/@form-validation/esm/plugin-bootstrap5/index.js"

// Connects to data-controller="validators--contact"
export default class extends Controller {
    connect() {
        //console.log('ContactController connected');
        this.initializeValidation();
    }

    initializeValidation() {
        const form = document.getElementById('frm-contact');
        if (!form) {
            console.error('Contact form element not found');
            return;
        }

        // Save the validation instance to this.validation
        this.validation = formValidation(form, {
            fields: {
                'contact[first_name]': {
                    validators: {
                        notEmpty: {
                            message: 'First name is required'
                        },
                        stringLength: {
                            min: 2,
                            max: 50,
                            message: 'First name must be between 2 and 50 characters'
                        }
                    }
                },
                'contact[last_name]': {
                    validators: {
                        notEmpty: {
                            message: 'Last name is required'
                        },
                        stringLength: {
                            min: 2,
                            max: 50,
                            message: 'Last name must be between 2 and 50 characters'
                        }
                    }
                },
                'contact[email]': {
                    validators: {
                        notEmpty: {
                            message: 'Email address is required'
                        },
                        emailAddress: {
                            message: 'Please enter a valid email address'
                        }
                    }
                },
                'contact[message]': {
                    validators: {
                        notEmpty: {
                            message: 'Message is required'
                        },
                        stringLength: {
                            min: 10,
                            max: 2000,
                            message: 'Your message must be between 10 and 2000 characters'
                        }
                    }
                }
            },
            plugins: {
                trigger: new plugins.Trigger({
                    event: 'blur'
                }),
                submitButton: new plugins.SubmitButton(),
                bootstrap5: new Bootstrap5.Bootstrap5({
                    rowSelector: '.fv-row',
                    eleInvalidClass: 'is-invalid',
                    eleValidClass: 'is-valid',
                }),
                aria: new plugins.Aria(),
            }
        }).on('core.form.valid', function (e) {
            form.submit();
        })
            .on('core.form.invalid', function (e) {
                //console.log('Form is invalid!');
            });
    }

    disconnect() {
        // Clean up FormValidation instance when the controller is disconnected
        if (this.validation) {
            this.validation.destroy();
        }
    }
}
